import { useQuery } from "@apollo/client/react";

import { GET_AI_SETTINGS } from "./gql";

type UseIntelligenceSettingsOptions = {
  refreshOnMount?: boolean;
};

const useIntelligenceSettings = ({ refreshOnMount }: UseIntelligenceSettingsOptions = {}) => {
  const { data, loading, error } = useQuery(GET_AI_SETTINGS, {
    fetchPolicy: refreshOnMount ? "cache-and-network" : "cache-first",
  });

  const aiFeaturesTerms = data?.spaceliftIntelligenceTermsLatestVersion;
  const aiFeaturesTermsAccepted = !!data?.spaceliftIntelligenceTermsAccepted;
  const canUseAiFeatures = aiFeaturesTermsAccepted && !!data?.spaceliftIntelligenceEnabled;
  const canUseInfraAssistant = canUseAiFeatures && !!data?.infraAssistantEnabled;
  const canUseInfraAssistantBuildMode =
    canUseInfraAssistant && !!data?.infraAssistantBuildModeEnabled;
  const isInitialLoading = loading && !data;

  return {
    aiFeaturesTerms,
    aiFeaturesTermsAccepted,
    canUseAiFeatures,
    canUseInfraAssistant,
    canUseInfraAssistantBuildMode,
    loading: isInitialLoading,
    error,
  };
};

export default useIntelligenceSettings;
